import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useMediaQuery, useTheme } from "@mui/material";

const steps = [
  "Placed",
  "Order Accepted",
  "Shipped",
  "Out For Delivery",
  "Delivered"
];

export default function OrderTracker({ activeStep }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stepper
      activeStep={activeStep - 1}
      alternativeLabel={isMobile}
      orientation={isMobile ? "horizontal" : "horizontal"}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        "& .MuiStepConnector-line": {
          borderColor: "#e5e7eb",
        },
        "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
          borderColor: "#374151",
        },
        "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
          borderColor: "#374151",
        },
        "& .MuiStep-root": {
          padding: isMobile ? "8px 4px" : "16px 8px",
          minWidth: isMobile ? "60px" : "80px",
        },
        "& .MuiStepLabel-root": {
          padding: 0,
          width: "100%",
        },
      }}
    >
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < activeStep;
        const isActive = stepNumber === activeStep;

        return (
          <Step key={label}>
            <StepLabel
              sx={{
                "& .MuiStepIcon-root": {
                  color: isActive || isCompleted ? "#374151" : "#d1d5db",
                  fontSize: isMobile ? "1.2rem" : "1.5rem",
                  "&.Mui-active": {
                    color: "#374151",
                  },
                  "&.Mui-completed": {
                    color: "#374151",
                  }
                },
                "& .MuiStepLabel-label": {
                  color: isActive || isCompleted ? "#374151" : "#9ca3af",
                  fontWeight: isActive ? "600" : isCompleted ? "500" : "400",
                  fontSize: isMobile ? "0.75rem" : "0.875rem",
                  mt: 1,
                  textAlign: "center",
                  wordBreak: "break-word",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  lineHeight: 1.2,
                  maxWidth: "100%",
                },
                "& .MuiStepLabel-labelContainer": {
                  "& .MuiStepLabel-optional": {
                    display: "none"
                  },
                  width: "100%",
                  textAlign: "center",
                }
              }}
            >
              {label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>

  );
}
